import { useState } from 'react';
import clsx from 'clsx';
import BottomDrawer from '../../../../../../../common/_custom/BottomDrawer/BottomDrawer';
import useFetchFilteredViewData from '../../../../../../../common/FilteredViewsButton/useFetchFilteredViewData';
import { GREY_DROPDOWN_CARET, PURPLE_CHECK_SMALL } from '../../../../../../../assets/hostedassets';
import styles from './MobileViewSheet.module.scss';

type FilteredViewOption = {
    label: string;
    value: string;
    endLabel?: string;
    columns?: string[];
};

interface MobileViewSheetProps {
    source: string;
    selectedView: FilteredViewOption | null;
    onViewSelect: (filters: Record<string, any>, columns?: string[]) => void;
    onSelectedViewChange: (view: FilteredViewOption | null) => void;
    onFiltersApply: (filters: Record<string, any>) => void;
    onFilterValuesUpdate?: (filters: Record<string, any>) => void;
    onClear?: () => void;
}

function MobileViewSheet({
    source,
    selectedView,
    onViewSelect,
    onSelectedViewChange,
    onFiltersApply,
    onFilterValuesUpdate,
    onClear,
}: MobileViewSheetProps) {
    const [showSheet, setShowSheet] = useState(false);
    const { filteredViews, isLoading, filterMapMemo } = useFetchFilteredViewData(source);

    const handleSelect = (view: FilteredViewOption) => {
        onSelectedViewChange(view);
        const filterData = filterMapMemo.get(view.value);
        if (filterData) {
            onViewSelect(filterData.filters || {}, view.columns);
            onFiltersApply(filterData.filters || {});
            onFilterValuesUpdate?.(filterData.filters || {});
        }
        setShowSheet(false);
    };

    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation();
        onSelectedViewChange(null);
        onViewSelect({}, []);
        onFiltersApply({});
        onFilterValuesUpdate?.({});
        onClear?.();
    };

    return (
        <>
            <button
                className={clsx(styles.ViewButton, {
                    [styles.ViewActive]: !!selectedView,
                })}
                onClick={() => setShowSheet(true)}
            >
                <span className={styles.ViewLabel}>{selectedView?.label || 'Select View'}</span>
                {selectedView ? (
                    <span className={styles.ClearIcon} onClick={handleClear}>
                        ✕
                    </span>
                ) : (
                    <img src={GREY_DROPDOWN_CARET} width={16} height={16} alt="" />
                )}
            </button>

            {showSheet && (
                <BottomDrawer onClose={() => setShowSheet(false)} height="50vh" showHeading heading="Select View">
                    <div className={styles.Body}>
                        {isLoading ? (
                            <div className={styles.Loading}>Loading views...</div>
                        ) : filteredViews.length === 0 ? (
                            <div className={styles.Empty}>No saved views</div>
                        ) : (
                            filteredViews.map((view) => (
                                <button
                                    key={view.value}
                                    className={clsx(styles.ViewItem, {
                                        [styles.ViewItemActive]: selectedView?.value === view.value,
                                    })}
                                    onClick={() => handleSelect(view)}
                                >
                                    <span className={styles.ViewItemLabel}>{view.label}</span>
                                    {selectedView?.value === view.value && (
                                        <img src={PURPLE_CHECK_SMALL} width={16} height={16} alt="" />
                                    )}
                                </button>
                            ))
                        )}
                    </div>
                </BottomDrawer>
            )}
        </>
    );
}

export default MobileViewSheet;
